module.exports = __webpack_public_path__ + "img/felix_gumbsch_3.0a442514.jpg";